var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Morebuttons } from '../Controls/Buttons';
import React, { useState, useEffect } from 'react';
import { Postgame } from '../PostGameScreen/PostgameScreen';
import { Link } from 'react-router-dom';
import StarIconFilled from '@mui/icons-material/Star';
import { stick } from '../../common/assets/stick.js';
import ClearIcon from '@mui/icons-material/Clear';
import { pteroIMG, pidgeionIMG, turkeyIMG, penguinIMG, } from '../../common/assets/birdImages';
import { getstats, handleStats, handleWord, learned, } from '../../common/functions';
import './gameScreen.css';
export function Card(props) {
    var _a = useState([]), guessed = _a[0], setGuessed = _a[1];
    var _b = useState(0), score = _b[0], setScore = _b[1];
    var _c = useState(0), streak = _c[0], setStreak = _c[1];
    var _d = useState({
        new: 0,
        answers: 0,
        correctAnswers: 0,
        learned: 0,
        bigStreak: 0,
    }), statsData = _d[0], setStatsData = _d[1];
    var _e = useState(false), load = _e[0], isLoad = _e[1];
    var _f = useState({}), userStats = _f[0], setUserStats = _f[1];
    useEffect(function () {
        function loadstats() {
            return __awaiter(this, void 0, void 0, function () {
                var resp;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, getstats()];
                        case 1:
                            resp = _a.sent();
                            if (resp) {
                                isLoad(true);
                                setUserStats(resp);
                            }
                            return [2 /*return*/];
                    }
                });
            });
        }
        loadstats();
    }, [props.reset]);
    useEffect(function () {
        if (props.reset) {
            if (load) {
                handleStats(userStats, statsData, 'sprint');
            }
            setStatsData(function () {
                return {
                    new: 0,
                    answers: 0,
                    correctAnswers: 0,
                    learned: 0,
                    bigStreak: 0,
                };
            });
        }
        else {
            isLoad(false);
            setGuessed(function () { return []; });
            setStreak(0);
            setScore(0);
        }
    }, [props.reset]);
    useEffect(function () {
        function qwer() {
            if (load)
                handleStats(userStats, statsData, 'sprint');
        }
        window.addEventListener('beforeunload', qwer);
        return function () {
            window.removeEventListener('beforeunload', qwer);
        };
    }, [load, statsData, userStats]);
    function updateGameState(correct, elem) {
        var _a, _b;
        var a = (_b = (_a = elem.properties) === null || _a === void 0 ? void 0 : _a.optional) === null || _b === void 0 ? void 0 : _b.isKnown;
        var b = elem.isNew;
        var strk = streak;
        if (elem.correct === correct) {
            strk += 1;
            setStreak(function (streak) {
                return streak + 1;
            });
            handleWord(elem, true, 'sprint');
            elem.guessedCorrect = true;
            setGuessed(function (oldArray) { return __spreadArray(__spreadArray([], oldArray, true), [elem], false); });
            setScore(function (score) {
                return score + 10 * Math.pow(2, Math.floor(streak / 4));
            });
        }
        else {
            strk = strk - 4 > 0 ? strk - 4 : 0;
            setStreak(streak - 4 > 0 ? streak - 4 : 0);
            elem.guessedCorrect = false;
            handleWord(elem, false, 'sprint');
            setGuessed(function (oldArray) { return __spreadArray(__spreadArray([], oldArray, true), [elem], false); });
        }
        setStatsData(function (statsData) {
            var _a, _b;
            return (statsData = {
                new: statsData.new + (b ? 1 : 0),
                answers: statsData.answers + 1,
                correctAnswers: statsData.correctAnswers + (elem.guessedCorrect ? 1 : 0),
                learned: statsData.learned + learned(a, (_b = (_a = elem.properties) === null || _a === void 0 ? void 0 : _a.optional) === null || _b === void 0 ? void 0 : _b.isKnown),
                bigStreak: statsData.bigStreak > strk ? statsData.bigStreak : strk,
            });
        });
    }
    var stars = function (strk, mult) {
        var arr = [];
        for (var index = 0; index < 3; index++) {
            if (index < strk % mult)
                arr.push(React.createElement(StarIconFilled, { key: index, sx: { color: '#FC0', fontSize: '60px' } }));
            else
                arr.push(React.createElement(StarIconFilled, { sx: { color: '#51876f', fontSize: '60px' } }));
        }
        return arr;
    };
    var birds = function (strk, mult) {
        var arr = [pteroIMG(), pidgeionIMG(), turkeyIMG(), penguinIMG()];
        return [arr[0]].concat(arr.slice(1, 1 + (Math.floor(strk / mult) > 5 ? 4 : Math.floor(strk / mult))));
    };
    if (props.noWords || props.items.length === 0)
        return (React.createElement("div", null,
            React.createElement(Link, { to: "/", className: "exit_link" },
                React.createElement(ClearIcon, { onClick: function () {
                        if (load)
                            handleStats(userStats, statsData, 'sprint');
                    }, sx: { fontSize: 40, color: 'white' } })),
            "\u0412\u044B \u043E\u0442\u0433\u0430\u0434\u0430\u043B\u0438 \u0432\u0441\u0435 \u0441\u043B\u043E\u0432\u0430. \u0412\u044B\u0439\u0434\u0438\u0442\u0435 \u0438\u0437 \u0438\u0433\u0440\u044B \u0434\u043B\u044F \u0432\u044B\u0431\u043E\u0440\u0430 \u0434\u0440\u0443\u0433\u043E\u0433\u043E \u0443\u0440\u043E\u0432\u043D\u044F \u0441\u043B\u043E\u0436\u043D\u043E\u0441\u0442\u0438 \u0438\u043B\u0438 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B \u0443\u0447\u0435\u0431\u043D\u0438\u043A\u0430"));
    else if (!props.end) {
        return (React.createElement("div", null,
            React.createElement("div", { className: "gameBoard" },
                React.createElement("div", { className: "info" },
                    React.createElement(Link, { to: "/", className: "exit_link" },
                        React.createElement(ClearIcon, { onClick: function () {
                                if (load)
                                    handleStats(userStats, statsData, 'sprint');
                            }, sx: { fontSize: 40, color: 'white' } })),
                    React.createElement("div", { className: "starscontainer" }, stars(streak, 4)),
                    React.createElement("span", { className: "Score" },
                        "Score:",
                        score)),
                React.createElement("div", null, birds(streak, 4)),
                React.createElement("div", { className: "stick", dangerouslySetInnerHTML: { __html: stick } }),
                React.createElement(Morebuttons, { elems: props.items, updatefunc: updateGameState, known: guessed, endfunc: props.endfunc }))));
    }
    else {
        return (React.createElement("div", null,
            React.createElement(Link, { to: "/", className: "exit_link" },
                React.createElement(ClearIcon, { onClick: function () {
                        if (load)
                            handleStats(userStats, statsData, 'sprint');
                    }, sx: { fontSize: 40, color: 'white' } })),
            React.createElement(Postgame, { elements: guessed, func: props.func })));
    }
}
